import { useQuery } from '@tanstack/react-query'
import { aiStudioService, themeService } from '../../../service/aiStudio'

export const useGetThemes = (type?: string, page = 1, limit = 20) => {
  return useQuery({
    queryKey: ['ai-studio', 'themes'],
    queryFn: () => themeService.getAllThemes(),
    staleTime: 30000,
  })
}
